// Vendors
import React from 'react';
// Components
import { LayoutComponent } from 'components/layout/layout.component';
// Contexts
import { KycContextConsumerHOC } from './contexts/kyc.context';
import { FetchErrorContextConsumerHOC } from 'contexts/fetch-error.context';
// Enumerations
import { KycStatesEnumeration } from './enumerations/kyc-states.enumeration';
// Constants
import {
  KYC_LAYOUT_ASSET_COMPONENT_PROPS,
  KYC_LAYOUT_COMPONENT_PROPS,
} from 'containers/kyc/constants/kyc.constants';
// Hooks
import { useKycHook } from './hooks/kyc.hook';
// Translations
import { KYC_DESCRIPTIONS, KYC_TITLES } from './translations/kyc.translations';
// Views
import { KycBizumView } from './views/bizum/kyc-bizum.view';
import { KycLandingView } from './views/landing/kyc-landing.view';
import { KycMethodView } from './views/method/kyc-method.view';
// Utilities
import { getLayoutContentComponent } from './utils/kyc.utils';

const KycBaseContainer = (): React.JSX.Element => {
  const { kycState, ...restHook } = useKycHook();

  const KycFlowComponent: React.FC = {
      [KycStatesEnumeration.BIZUM]: KycBizumView,
      [KycStatesEnumeration.LANDING]: KycLandingView,
      [KycStatesEnumeration.METHOD]: KycMethodView,
    }[kycState],
    LayoutContentStyledComponent = getLayoutContentComponent(kycState);

  return (
    <LayoutContentStyledComponent>
      <LayoutComponent
        {...{ ...KYC_LAYOUT_COMPONENT_PROPS, ...restHook }}
        assetId={KYC_LAYOUT_ASSET_COMPONENT_PROPS[kycState]}
        title={KYC_TITLES[kycState]}
        description={KYC_DESCRIPTIONS[kycState]}
      >
        <KycFlowComponent />
      </LayoutComponent>
    </LayoutContentStyledComponent>
  );
};

const KycContainer = KycContextConsumerHOC(FetchErrorContextConsumerHOC(KycBaseContainer));

export { KycContainer };
